import React from 'react';
import { connect } from 'react-redux';
import { CheckObligation } from './checkObligation';

const Conteiner = ({currentStep, children, fieldConditional, field}) => {
  const steps = currentStep ? [...currentStep.Campos] : [];
  
  return (<CheckObligation steps={steps} children={children}  fieldConditional={fieldConditional} fieldKey={field} />)
};

const mapStateToProps = (state, ownProps) => ({
  currentStep: ownProps.currentStep
});

export default connect(
  mapStateToProps
)(Conteiner);
